<template>
  <div class="no-select" v-if="Array.isArray(remocao.status)">
    <div class="flex items-center m-b-xs" v-for="(s, i) in remocao.status">
      <span class="m-r-xs font-bold">#{{i+1}}</span> <status-remocao-selector :status="s.status" />
    </div>
  </div>
  <status-remocao-selector class="no-select" v-else :status="remocao.status" />
</template>

<script>
import StatusRemocaoSelector from './StatusRemocaoSelector';
export default {
  name: 'StatusRemocao',
  components: {StatusRemocaoSelector},
  props: ['remocao']
}
</script>

<style scoped>

</style>
